import React from "react";
import _ from "lodash";

import UnitsSelector from "components/common/UnitsSelector";
import ClickToCopyWrapper from "components/common/ClickToCopyWrapper";

import PriceUnit from "./PriceUnit";
import PriceEditModeControl from "./PriceEditModeControl";
import {
  getCatchallPricesLimit,
  getDetectorPricesLimit,
  getPricesLimit,
  getXPricesLimit,
  _validateUnitSettingRule,
} from "./UPRSegmentationHelper";

import { inputClass, buttonActionRedClass } from "helpers/StyleClass";

import { FaTrash } from "react-icons/fa";

class UnitSettingEditView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
    };

    this.handleValidChanged = this.handleValidChanged.bind(this);
    this.handleRuleChange = this.handleRuleChange.bind(this);
  }

  handleRuleChange(obj) {
    const { rule } = this.props;

    if (this.props.handleRuleChange) {
      const newObj = _.omitBy(
        {
          ...rule,
          ...obj,
        },
        _.isUndefined
      );
      this.props.handleRuleChange(newObj);
    }
  }

  // filter the errors
  // if list is empty, means all the price setting is valid
  handleValidChanged(errors) {
    const list = _.filter(errors, (e) => e !== "");
    if (this.props.handleValidChanged) {
      this.props.handleValidChanged(list);
    }
  }

  render() {
    const {
      rule,
      suggestion,
      networkId,
      optimization,
      index,
      allUnits,
      isVerified,
    } = this.props;

    return (
      <div className="rounded border relative flex flex-col border-gray-400 p-2 text-sm text-gray-800">
        <button
          className={`${buttonActionRedClass} absolute`}
          style={{ top: "0.25rem", right: "0.25rem" }}
          onClick={this.props.handleRuleDelete}
        >
          <FaTrash></FaTrash>
        </button>

        <div className="mb-2 w-1/2">
          <label className="font-semibold">[{index + 1}] ID: </label>
          <input
            type="text"
            className={inputClass}
            value={rule.id}
            onChange={(e) =>
              this.handleRuleChange({
                id: _.isNaN(_.toNumber(e.target.value))
                  ? e.target.value
                  : _.toNumber(e.target.value),
              })
            }
          ></input>
          {isVerified && (
            <CheckValidView value={rule.id} objKey={"id"}></CheckValidView>
          )}
        </div>

        <div className="mb-2 w-1/2">
          <label className="font-semibold">Name: </label>
          <input
            type="text"
            className={inputClass}
            value={rule.name}
            onChange={(e) => this.handleRuleChange({ name: e.target.value })}
          ></input>
          {isVerified && (
            <CheckValidView value={rule.name} objKey={"name"}></CheckValidView>
          )}
        </div>

        <div className="mb-2">
          <div className="font-semibold">Units: ({rule.units.length})</div>
          <UnitsSelector
            networkId={networkId}
            selectedItems={rule.units}
            disabledItems={allUnits}
            selectMetric="unitId"
            handleChanged={(list) => this.handleRuleChange({ units: list })}
          ></UnitsSelector>
          {isVerified && (
            <CheckValidView
              value={rule.units}
              objKey={"units"}
            ></CheckValidView>
          )}
        </div>

        <AllThePricesView
          optimization={optimization}
          prices={rule.prices}
          isVerified={isVerified}
          unitPriceSuggestions={suggestion}
          detector_prices={rule.detector_prices}
          catchall_prices={rule.catchall_prices || []}
          x_prices={rule.x_prices || []}
          handleValidChanged={(list) => this.handleValidChanged(list)}
          handlePricesChanged={(obj) => this.handleRuleChange(obj)}
        ></AllThePricesView>
      </div>
    );
  }
}

class AllThePricesView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      valid: ["", "", "", ""],
    };

    this.handlePricesChanged = this.handlePricesChanged.bind(this);
    this.handleValidChanged = this.handleValidChanged.bind(this);
  }

  handlePricesChanged(list, priceKey) {
    if (this.props.handlePricesChanged) {
      this.props.handlePricesChanged({
        [priceKey]: list,
      });
    }
  }

  // valid array: [ price, detector, catchall, x ]
  // if valid, set "" to the index
  // if invalid, set the error message to the index
  handleValidChanged(flag, idx) {
    const list = [...this.state.valid];
    list[idx] = flag;

    this.setState(
      {
        valid: list,
      },
      () => {
        this.props.handleValidChanged(this.state.valid);
      }
    );
  }

  render() {
    const {
      optimization,
      prices,
      unitPriceSuggestions,
      detector_prices,
      catchall_prices,
      x_prices,
      isVerified,
    } = this.props;

    return (
      <div>
        <label className="font-semibold text-gray-800">
          Prices:
          {optimization !== "dt" && <span>({prices.length})</span>}
        </label>
        <div className="mb-2 bg-white p-2">
          {optimization !== "dt" ? (
            <PriceEditModeControl
              prices={prices}
              preventInitCheck={false}
              limit={getPricesLimit({ optimization })}
              showErrMsg={isVerified}
              handleSync={(list) => this.handlePricesChanged(list, "prices")}
              handleValidChanged={(flag) =>
                this.handleValidChanged(
                  flag ? "" : "Prices setting is invalid.",
                  0
                )
              }
            ></PriceEditModeControl>
          ) : (
            "-"
          )}
        </div>

        {unitPriceSuggestions && (
          <div className="mb-2 text-orange-700">
            <span className="font-semibold">
              Suggestion:(
              {unitPriceSuggestions && unitPriceSuggestions.length})
            </span>{" "}
            <div className="bg-white p-2">
              <div className="border rounded border-gray-400 bg-gray-200 p-2">
                {unitPriceSuggestions ? (
                  <div className="flex flex-wrap gap-1">
                    {unitPriceSuggestions.map((p, idx) => {
                      return (
                        <PriceUnit
                          price={p}
                          key={`${idx}-${p}`}
                          readOnly={true}
                          tooltip={idx + 1}
                          textColor="text-orange-700"
                        ></PriceUnit>
                      );
                    })}
                    <ClickToCopyWrapper
                      copyText={unitPriceSuggestions.join(", ")}
                    ></ClickToCopyWrapper>
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>
        )}

        <label className="font-semibold text-gray-800">
          Detector Prices: ({detector_prices.length})
        </label>

        <div className="mb-2 bg-white p-2">
          <PriceEditModeControl
            prices={detector_prices}
            preventInitCheck={false}
            limit={getDetectorPricesLimit({ optimization })}
            showErrMsg={isVerified}
            handleSync={(list) =>
              this.handlePricesChanged(list, "detector_prices")
            }
            handleValidChanged={(flag) =>
              this.handleValidChanged(
                flag ? "" : "Detector Prices setting is invalid.",
                1
              )
            }
          ></PriceEditModeControl>
        </div>

        <label className="font-semibold text-gray-800">
          Catchall Prices: {catchall_prices && <>({catchall_prices.length})</>}
        </label>
        <div className="mb-2 bg-white p-2">
          {catchall_prices ? (
            <PriceEditModeControl
              prices={catchall_prices}
              preventInitCheck={false}
              limit={getCatchallPricesLimit({ optimization })}
              showErrMsg={isVerified}
              handleSync={(list) =>
                this.handlePricesChanged(
                  list.length === 0 ? undefined : list,
                  "catchall_prices"
                )
              }
              handleValidChanged={(flag) =>
                this.handleValidChanged(
                  flag ? "" : "Catchall Prices setting is invalid.",
                  2
                )
              }
            ></PriceEditModeControl>
          ) : (
            "-"
          )}
        </div>

        <label className="font-semibold text-gray-800">
          X Prices: {x_prices && <>({x_prices.length})</>}
        </label>
        <div className="mb-2 bg-white p-2">
          {x_prices ? (
            <PriceEditModeControl
              prices={x_prices}
              preventInitCheck={false}
              limit={getXPricesLimit({ optimization })}
              showErrMsg={isVerified}
              handleSync={(list) =>
                this.handlePricesChanged(
                  list.length === 0 ? undefined : list,
                  "x_prices"
                )
              }
              handleValidChanged={(flag) =>
                this.handleValidChanged(
                  flag ? "" : "X Prices setting is invalid.",
                  3
                )
              }
            ></PriceEditModeControl>
          ) : (
            "-"
          )}
        </div>
      </div>
    );
  }
}

class CheckValidView extends React.PureComponent {
  render() {
    const { value, objKey } = this.props;

    const errors = _validateUnitSettingRule({ [objKey]: value }, [objKey]);

    return (
      errors &&
      _.map(errors, (e, idx) => {
        return (
          <div
            className="my-1 bg-red-100 px-2 font-semibold  text-red-700"
            key={idx}
          >
            {e}
          </div>
        );
      })
    );
  }
}

export default UnitSettingEditView;
